document.addEventListener('DOMContentLoaded', function () {
  const selectedVariantBlock = document.getElementById('selectedVariantBlock');
  if (!selectedVariantBlock) return;

  // Get the target variant ID from the Liquid-rendered block
  const targetVariantId = parseInt(selectedVariantBlock.getAttribute('data-target-variant-id'));

  // Function to update the visibility of the block
  const updateSelectedVariantBlockVisibility = (selectedVariantId) => {
    if (selectedVariantId === targetVariantId) {
      selectedVariantBlock.style.display = 'block';
    } else {
      selectedVariantBlock.style.display = 'none';
    }
  };

  // Check for the Dawn theme's variant selector
  const variantSelectElement = document.querySelector('[name="id"]');
  if (!variantSelectElement) {
    console.warn('Variant selector not found.');
    return;
  }

  // Update block visibility based on the initially selected variant
  const initialVariantId = parseInt(variantSelectElement.value);
  updateSelectedVariantBlockVisibility(initialVariantId);

  // Listen for variant changes using the Dawn theme's JavaScript
  document.addEventListener('variantChange', (event) => {
    const selectedVariant = event.detail.variant;
    if (selectedVariant) {
      updateSelectedVariantBlockVisibility(selectedVariant.id);
    }
  });

  // Fallback: Listen for changes on the variant dropdown/radio buttons
  variantSelectElement.addEventListener('change', function () {
    const selectedVariantId = parseInt(this.value);
    updateSelectedVariantBlockVisibility(selectedVariantId);
  });
});
